export const COMPANY_INFO = {
  name: 'Hærvejens Træpleje',
  address: 'Seggelund Hovedvej 20',
  city: 'Christiansfeld',
  postalCode: '6070',
  country: 'Danmark',
  phone: '27 13 57 87',
  phoneRaw: '27135787',
  phoneDisplay: '+45 27 13 57 87',
  email: 'haervejenstraepleje@gmail.com',
  cvr: '42196169',
  mapsUrl: 'https://goo.gl/maps/Z627hqJaHaDeZR7V9',
  logoUrl: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/haervejens-traepleje-logo.png',
  iconUrl: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/haervejens-traepleje-logo-icon-wbg-150x150.png',
  insurance: 'Fuldt forsikret op til 10 mio. kr. hos Topdanmark',
  staffCount: '12 uddannede arborister og lærlinge fra Skovskolen',
  owner: 'Mathias Svendsen',
};

export const CORE_SERVICES = [
  {
    slug: 'traefaeldning',
    title: 'Træfældning',
    shortTitle: 'Træfældning',
    navLabel: 'Træfældning',
    intro: 'Vi tilbyder sikker og professionel træfældning til private og erhvervskunder i hele Østjylland og Trekantområdet. Vi planlægger hvert fald ned til mindste detalje og rydder pænt op bagefter.',
    icon: 'fa-tree',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traefaeldning.jpg',
    seoTitle: 'Træfældning udført af professionelle Arborister',
    metaDesc: 'Har du et træ, der skal fældes? Hærvejens Træpleje tilbyder professionel træfældning med fokus på sikkerhed. Vi fælder træet kontrolleret.',
  },
  {
    slug: 'topkapning',
    title: 'Topkapning',
    shortTitle: 'Topkapning',
    navLabel: 'Topkapning',
    intro: 'Vi tilbyder professionel topkapning til private og erhvervskunder. Vores certificerede arborister fjerner dit træ sikkert og kontrolleret, sektion for sektion, uanset hvor tæt det står på bygninger eller hegn.',
    icon: 'fa-tree-deciduous',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/topkapning-i-kolding.jpg',
    seoTitle: 'Professionel Topkapning',
    metaDesc: 'Har du et træ, der står svært tilgængeligt? Hærvejens Træpleje er specialister i topkapning. Vi fjerner træet sektion for sektion.',
  },
  {
    slug: 'stubfraesning',
    altSlug: 'rodfraesning',
    title: 'Stubfræsning & rodfræsning',
    shortTitle: 'Stubfræsning',
    navLabel: 'Rodfræsning',
    intro: 'Vi tilbyder effektiv stubfræsning (rodfræsning) til kunder i hele Østjylland og Trekantområdet. Vi fjerner stubben hurtigt og skånsomt, så du kan komme videre med dine haveplaner.',
    icon: 'fa-gear',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/stubfraesning.jpg',
    seoTitle: 'Rodfræsning - Hærvejens Træpleje',
    metaDesc: 'Har du en træstub, der står i vejen? Hærvejens Træpleje tilbyder professionel stubfræsning (også kaldet rodfræsning), der fjerner stubben.',
  },
  {
    slug: 'beskaering-af-traeer',
    altSlug: 'beskaering',
    title: 'Beskæring af træer',
    shortTitle: 'Beskæring',
    navLabel: 'Beskæring',
    intro: 'Vi tilbyder professionel beskæring af alle typer træer – herunder æbletræer, pæretræer og andre frugttræer. Vi mestrer kroneløft, kronetynding og kronereducering.',
    icon: 'fa-scissors',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/imageye-imgi-35-dsc00451-251.jpg',
    seoTitle: 'Træbeskæringsservice i Vejle - Kolding Træbeskæring',
    metaDesc: 'Effektiv beskæring af træer i Kolding og Vejle med fokus på sund vækst, sikkerhed og æstetik. Kontakt Hærvejens Træpleje for professionel træpleje.',
  },
  {
    slug: 'anlaeg',
    title: 'Nabo til jernbane? / anlæg',
    shortTitle: 'Nabo til jernbane?',
    navLabel: 'Nabo til jernbane?',
    intro: 'Bor du tæt på jernbanen? Dit træ kan koste dig dyrt. Hærvejens Træpleje har stor erfaring med fældning og risikovurdering af træer langs jernbaner og elledninger.',
    icon: 'fa-train-track',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/helsingor-bane.jpg',
    seoTitle: 'Anlæg - Hærvejens Træpleje',
    metaDesc: 'Bor du tæt på jernbanen? Dit træ kan koste dig dyrt Hvert år vælter hundredvis af træer ned over jernbanen i Danmark. Alene i 2023 og 2024 var det over 550 træer.',
  },
  {
    slug: 'haekklipning',
    title: 'Hækklipning',
    shortTitle: 'Hækklipning',
    navLabel: 'Hækklipning',
    intro: 'Hækklipning for private og virksomheder. Vi råder over professionelt udstyr med teleskopstænger, der når høje hække og buske fra jorden – effektivt og ordentligt.',
    icon: 'fa-leaf',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/haek-haervejens-traepleje-117-300x300.jpg',
    seoTitle: 'Effektiv Hækkeklipning til Private & Erhverv - Hærvejens Træpleje',
    metaDesc: 'Hækklipning for private og virksomheder i Fredericia, Kolding & Vejle. Vi håndterer alt fra lave hække til høje buske – effektivt og professionelt. Kontakt os!',
  },
  {
    slug: 'alm-skovning',
    title: 'Alm. skovning',
    shortTitle: 'Alm. skovning',
    navLabel: 'Alm. skovning',
    intro: 'Vi tilbyder også almindelig håndskovning. Har du et mindre eller større skovstykke, som trænger til at blive tyndet i, eller skal du have skovet jagtspor?',
    icon: 'fa-axe',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg',
    seoTitle: 'Alm. skovning - Hærvejens Træpleje',
    metaDesc: 'Hånd skovning Vi tilbyder også almindlig håndskovning. Har du et mindre eller stører skov stykke, som trænger til at blive tyndet i? eller går du meget på jagt?',
  },
];

export const MAIN_AREAS = [
  {
    slug: 'kolding',
    name: 'Kolding',
    region: 'Trekantområdet',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/kolding.jpg',
    heroImage: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traepleje-i-kolding.jpg',
    seoTitle: 'Træpleje i Kolding',
    metaDesc: 'Brug for professionel træpleje i Kolding? Hærvejens Træpleje tilbyder alt fra fældning og topkapning til rodfræsning.',
    introHeadline: 'Professionel træpleje i Kolding: Fra slotshaven til din egen have',
    nearbySlugs: ['fredericia', 'vejle', 'horsens'],
    localPages: [
      { slug: 'traefaeldning-i-kolding', title: 'Træfældning i Kolding', service: 'Træfældning' },
      { slug: 'topkapning-kolding', title: 'Topkapning i Kolding', service: 'Topkapning' },
      { slug: 'rodfraesning-i-kolding', title: 'Rodfræsning i Kolding', service: 'Rodfræsning' },
    ],
  },
  {
    slug: 'fredericia',
    name: 'Fredericia',
    region: 'Trekantområdet',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/fredericia.jpg',
    heroImage: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traepleje-i-fredericia-2.jpg',
    seoTitle: 'Træpleje i Fredericia',
    metaDesc: 'Har du brug for træpleje i Fredericia? Hærvejens Træpleje tilbyder fældning, topkapning og rodfræsning med respekt for byens unikke haver',
    introHeadline: 'Træpleje i Fredericia: Ekspertise fra voldene til villahaven',
    nearbySlugs: ['kolding', 'vejle', 'horsens'],
    localPages: [
      { slug: 'traefaeldning-i-fredericia', title: 'Træfældning i Fredericia', service: 'Træfældning' },
      { slug: 'topkapning-fredericia', title: 'Topkapning i Fredericia', service: 'Topkapning' },
      { slug: 'rodfraesning-i-fredericia', title: 'Rodfræsning i Fredericia', service: 'Rodfræsning' },
    ],
  },
  {
    slug: 'vejle',
    name: 'Vejle',
    region: 'Trekantområdet',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/vejle.jpg',
    heroImage: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traefaeldning.jpg',
    seoTitle: 'Træpleje i Vejle - Fældning, Topkapning og Rodfræsning',
    metaDesc: 'Har du brug for professionel træpleje i Vejle? Hærvejens Træpleje er dit lokale team af arborister, der klarer alt fra fældning til beskæring',
    introHeadline: 'Træpleje i Vejle: Eksperter i byens bakkede haver',
    nearbySlugs: ['kolding', 'fredericia', 'horsens'],
    localPages: [
      { slug: 'traefaeldning-i-vejle', title: 'Træfældning i Vejle', service: 'Træfældning' },
      { slug: 'topkapning-vejle', title: 'Topkapning i Vejle', service: 'Topkapning' },
      { slug: 'rodfraesning-i-vejle', title: 'Rodfræsning i Vejle', service: 'Rodfræsning' },
    ],
  },
  {
    slug: 'horsens',
    name: 'Horsens',
    region: 'Østjylland',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/horsens.jpg',
    heroImage: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traepleje-i-horsens-hurtigt-tilbud-fra-din-lokale-arborist.jpg',
    seoTitle: 'Træpleje i Horsens | Hurtigt tilbud fra din lokale arborist',
    metaDesc: 'Har du træer i haven i Horsens, der er blevet for store, er syge, eller blot trænger til en professionel hånd? Hærvejens Træpleje er dit lokale team af certificerede arborister, der tilbyder komplet træpleje i Horsens.',
    introHeadline: 'Professionel Træpleje i Horsens: Få hjælp af lokale arborister',
    nearbySlugs: ['skanderborg', 'vejle', 'aarhus'],
    localPages: [
      { slug: 'traefaeldning-i-horsens', title: 'Træfældning i Horsens', service: 'Træfældning' },
      { slug: 'topkapning-horsens', title: 'Topkapning i Horsens', service: 'Topkapning' },
      { slug: 'rodfraesning-i-horsens', title: 'Rodfræsning i Horsens', service: 'Rodfræsning' },
    ],
  },
  {
    slug: 'skanderborg',
    name: 'Skanderborg',
    region: 'Østjylland',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/skanderborg.jpg',
    heroImage: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traepleje-i-skanderborg.jpg',
    seoTitle: 'Træpleje i Skanderborg',
    metaDesc: 'Har du brug for professionel træpleje i Skanderborg? Hærvejens Træpleje er dit lokale team af arborister. Alt fra fældning til beskæring.',
    introHeadline: 'Professionel Træpleje i Skanderborg og omegn',
    nearbySlugs: ['horsens', 'aarhus', 'vejle'],
    localPages: [
      { slug: 'traefaeldning-i-skanderborg', title: 'Træfældning i Skanderborg', service: 'Træfældning' },
      { slug: 'topkapning-skanderborg', title: 'Topkapning i Skanderborg', service: 'Topkapning' },
      { slug: 'rodfraesning-i-skanderborg', title: 'Rodfræsning i Skanderborg', service: 'Rodfræsning' },
    ],
  },
  {
    slug: 'aarhus',
    name: 'Aarhus',
    region: 'Østjylland',
    image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/aarhus.jpg',
    heroImage: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traepleje-i-aarhus.jpg',
    seoTitle: 'Træpleje i Aarhus',
    metaDesc: 'Brug for professionel træpleje i Aarhus? Hærvejens Træpleje er dit lokale team af uddannede arborister. Alt fra træfældning til beskæring.',
    introHeadline: 'Professionel Træpleje i Aarhus: Få hjælp af uddannede arborister',
    nearbySlugs: ['skanderborg', 'horsens', 'vejle'],
    localPages: [
      { slug: 'traefaeldning-i-aarhus', title: 'Træfældning i Aarhus', service: 'Træfældning' },
      { slug: 'topkapning-aarhus', title: 'Topkapning i Aarhus', service: 'Topkapning' },
      { slug: 'rodfraesning-aarhus', title: 'Rodfræsning i Aarhus', service: 'Rodfræsning' },
    ],
  },
];

export const GALLERY_ITEMS = [
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traefaeldning.jpg',
    title: 'Sikker fældning af stort bøgetræ',
    category: 'Træfældning',
    alt: 'Træfældning udført af Hærvejens Træpleje',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/topkapning-i-kolding.jpg',
    title: 'Topkapning og sektionsfældning i villahave',
    category: 'Topkapning',
    alt: 'Topkapning i Kolding i trange rammer',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/stubfraesning.jpg',
    title: 'Rodfræsning under terræn',
    category: 'Stubfræsning',
    alt: 'Stubfræsning og rodfræsning',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/beskaring1.jpg',
    title: 'Beskæring og formning af frugttræer',
    category: 'Beskæring',
    alt: 'Beskæring af træ af certificeret arborist',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/dsc00451-251.jpg',
    title: 'Præcisionsfældning i højden',
    category: 'Træfældning',
    alt: 'Professionel træfældning',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/topkapning-fredericia-1-1024x572.jpg',
    title: 'Arbejdet i trækronen med klatreudstyr',
    category: 'Topkapning',
    alt: 'Arborist klatring og nedfiring',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/rodfraesning.jpg',
    title: 'Kompakt rodfræser i aktion',
    category: 'Stubfræsning',
    alt: 'Rodfræsning i have',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/billede1-229-1.jpg',
    title: 'Kroneudtynding for optimalt lysindfald',
    category: 'Beskæring',
    alt: 'Kroneudtynding af løvtræ',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/haek-haervejens-traepleje-117-300x300.jpg',
    title: 'Hækklipning og højdereducering med teleskopudstyr',
    category: 'Hækklipning',
    alt: 'Hækklipning udført af gartner',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/helsingor-bane.jpg',
    title: 'Sikkerhedsfældning langs jernbane og master',
    category: 'Skov & Bane',
    alt: 'Nabo til banen og jernbanearbejde',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg',
    title: 'Håndskovning og tynding af skovbevoksning',
    category: 'Skov & Bane',
    alt: 'Almindelig håndskovning',
  },
  {
    src: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/billede2-226-1.jpg',
    title: 'Kronereduktion af bevaringsværdigt træ',
    category: 'Beskæring',
    alt: 'Kronereduktion',
  },
];

export const TEAM_MEMBERS = [
  { name: 'Mathias Svendsen', role: 'Indehaver & Certificeret Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/mathias-svendsen-1-scaled-e1761900902121.jpg' },
  { name: 'Ebbe Andreas Østergaard Mikkelsen', role: 'Arborist og SR-OR leder', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Emil Høst Gjødrik', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Jacob Enevoldsen', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Jakob Thomhav Brødsgaard', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Kristian Kaltoft', role: 'Skovarbejder', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Oliver Lund Damsgaard', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Peter Kjær Berger', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Maxime Le Fluch', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Anders Poulsen', role: 'Arborist', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Viktor Toldberg Olsen', role: 'Arborist Elev', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
  { name: 'Trine Nykjær Jensen', role: 'Kontorassistent', image: 'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/akm-skov1-180.jpg' },
];

export const URL_MAPPING = [
  { oldUrl: '/', newUrl: '/', title: 'Forside' },
  { oldUrl: '/om-os/', newUrl: '/om-os', title: 'Om os' },
  { oldUrl: '/services/', newUrl: '/services', title: 'Services oversigt' },
  { oldUrl: '/traefaeldning/', newUrl: '/traefaeldning', title: 'Træfældning' },
  { oldUrl: '/topkapning/', newUrl: '/topkapning', title: 'Topkapning' },
  { oldUrl: '/stubfraesning/', newUrl: '/stubfraesning', title: 'Stubfræsning & Rodfræsning' },
  { oldUrl: '/beskaering-af-traeer/', newUrl: '/beskaering-af-traeer', title: 'Beskæring af træer' },
  { oldUrl: '/anlaeg/', newUrl: '/anlaeg', title: 'Nabo til jernbane? / Anlæg' },
  { oldUrl: '/haekklipning/', newUrl: '/haekklipning', title: 'Hækklipning' },
  { oldUrl: '/alm-skovning/', newUrl: '/alm-skovning', title: 'Alm. skovning' },
  { oldUrl: '/referencer/', newUrl: '/referencer', title: 'Referencer & Galleri' },
  { oldUrl: '/kontakt/', newUrl: '/kontakt', title: 'Kontakt' },
  { oldUrl: '/tak/', newUrl: '/tak', title: 'Tak' },
  { oldUrl: '/english/', newUrl: '/english', title: 'English' },
  { oldUrl: '/deutsch/', newUrl: '/deutsch', title: 'Deutsch' },
  { oldUrl: '/kolding/', newUrl: '/kolding', title: 'Træpleje i Kolding' },
  { oldUrl: '/fredericia/', newUrl: '/fredericia', title: 'Træpleje i Fredericia' },
  { oldUrl: '/vejle/', newUrl: '/vejle', title: 'Træpleje i Vejle' },
  { oldUrl: '/horsens/', newUrl: '/horsens', title: 'Træpleje i Horsens' },
  { oldUrl: '/skanderborg/', newUrl: '/skanderborg', title: 'Træpleje i Skanderborg' },
  { oldUrl: '/aarhus/', newUrl: '/aarhus', title: 'Træpleje i Aarhus' },
  { oldUrl: '/traefaeldning-i-kolding/', newUrl: '/traefaeldning-i-kolding', title: 'Træfældning i Kolding' },
  { oldUrl: '/topkapning-kolding/', newUrl: '/topkapning-kolding', title: 'Topkapning i Kolding' },
  { oldUrl: '/rodfraesning-i-kolding/', newUrl: '/rodfraesning-i-kolding', title: 'Rodfræsning i Kolding' },
  { oldUrl: '/traefaeldning-i-fredericia/', newUrl: '/traefaeldning-i-fredericia', title: 'Træfældning i Fredericia' },
  { oldUrl: '/topkapning-fredericia/', newUrl: '/topkapning-fredericia', title: 'Topkapning i Fredericia' },
  { oldUrl: '/rodfraesning-i-fredericia/', newUrl: '/rodfraesning-i-fredericia', title: 'Rodfræsning i Fredericia' },
  { oldUrl: '/traefaeldning-i-vejle/', newUrl: '/traefaeldning-i-vejle', title: 'Træfældning i Vejle' },
  { oldUrl: '/topkapning-vejle/', newUrl: '/topkapning-vejle', title: 'Topkapning i Vejle' },
  { oldUrl: '/rodfraesning-i-vejle/', newUrl: '/rodfraesning-i-vejle', title: 'Rodfræsning i Vejle' },
  { oldUrl: '/traefaeldning-i-horsens/', newUrl: '/traefaeldning-i-horsens', title: 'Træfældning i Horsens' },
  { oldUrl: '/topkapning-horsens/', newUrl: '/topkapning-horsens', title: 'Topkapning i Horsens' },
  { oldUrl: '/rodfraesning-i-horsens/', newUrl: '/rodfraesning-i-horsens', title: 'Rodfræsning i Horsens' },
  { oldUrl: '/traefaeldning-i-skanderborg/', newUrl: '/traefaeldning-i-skanderborg', title: 'Træfældning i Skanderborg' },
  { oldUrl: '/topkapning-skanderborg/', newUrl: '/topkapning-skanderborg', title: 'Topkapning i Skanderborg' },
  { oldUrl: '/rodfraesning-i-skanderborg/', newUrl: '/rodfraesning-i-skanderborg', title: 'Rodfræsning i Skanderborg' },
  { oldUrl: '/traefaeldning-i-aarhus/', newUrl: '/traefaeldning-i-aarhus', title: 'Træfældning i Aarhus' },
  { oldUrl: '/topkapning-aarhus/', newUrl: '/topkapning-aarhus', title: 'Topkapning i Aarhus' },
  { oldUrl: '/rodfraesning-aarhus/', newUrl: '/rodfraesning-aarhus', title: 'Rodfræsning i Aarhus' },
];
